import {gql} from "@apollo/client";
import filterDataGql, { executeQueryUtil } from '../utils/gqlUtil';
import apolloClient from "../apolloClient/ApolloClient";

const common = `
  id
  name
  rhId
`

export const getStaffsQuery = (brandId, establishmentId) => {
  var debug = `
    query {
      getStaffs(brandId: "${brandId}", establishmentId: "${establishmentId}") {
        ${common}
      }
    }
  `
  console.log(debug);

  return gql`
    query {
      getStaffs(brandId: "${brandId}", establishmentId: "${establishmentId}") {
        ${common}
      }
    }
  `;
}

export const updateStaffMutation = (brandId, establishmentId, data) => {
    delete data.updateDate;
    var dataString = filterDataGql(data, ["createdAt", "creationDate", "updateDate"],
        [] );

    var debug = `
    mutation {
      updateStaff(brandId: "${brandId}", establishmentId: "${establishmentId}", data: ${dataString}) {
        ${common}
      }
    }
  `

    console.log(debug);

    return gql`
    mutation {
        updateStaff(brandId: "${brandId}", establishmentId: "${establishmentId}", data: ${dataString}) {
            ${common}
        }
    }
  `;
}






